<div class="fuel-changes-map">
  <div class="fuel-changes-map__map">
    <app-common-map [mapHeight]="isCollapsed ? '598px' : '100vh'" [isCollapsed]="isCollapsed" [data]="filteredData"
      [selectedItem]="selectedItemLabel" [dropdownItems]="dropdownItems" [clusterRenderer]="clusterRenderer"
      [markerFactory]="markerFactory" [mapInfoWindowBuilder]="mapInfoWindowBuilder" [routeLink]="routeLink"
      [mapCenter]="mapCenter" [isLoading]="isLoading" [currencySymbol]="currencySymbol"
      (dropdownChange)="onDropdownChange($event)">
    </app-common-map>
  </div>
</div>